module.exports = __webpack_public_path__ + "assets/images/warning-icon.bbab3719cbfb1494aa29ad62e29fd67e.svg";